import { z } from 'zod';
/**
 * Assistant IA en langage naturel (ADR-0016). Contrat volontairement minimal : une question, une
 * réponse. La coquille livre le contrat ; le fournisseur concret (Claude/Gemini) est branché plus
 * tard, côté serveur, sans changer cette forme.
 */
/** Longueur maximale d'une question : au-delà, ce n'est plus une requête d'assistant. */
export const ASSISTANT_MESSAGE_MAX = 2000;
export const assistantQuerySchema = z.object({
    message: z.string().trim().min(1).max(ASSISTANT_MESSAGE_MAX),
    /**
     * Vidéo jointe à la conversation (ADR-0027, incrément 1). Seul l'**identifiant** voyage : le
     * serveur revalide l'appartenance à l'organisation (cloisonnement, 404 sinon) et résout le titre
     * de référence — le client n'en est jamais l'autorité. L'octet, lui, est déjà parti par l'upload
     * pré-signé, jamais par l'API.
     */
    videoId: z.string().min(1).optional(),
});
/** Fournisseurs pris en charge par l'interface. `null` quand l'assistant est dormant. */
export const ASSISTANT_PROVIDERS = ['claude', 'gemini'];
/**
 * Types d'**actions** que l'assistant peut **proposer** (ADR-0027, incrément 2). Jeu fermé et petit,
 * non destructeur. L'assistant ne **fait** jamais l'action : il la propose, l'utilisateur la confirme,
 * et le front appelle l'endpoint normal (gardé par le rôle, journalisé).
 */
export const AssistantActionKind = {
    ADOPT_LIBRARY_MODEL: 'ADOPT_LIBRARY_MODEL',
};
//# sourceMappingURL=assistant.js.map